import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function ApplySuccess() {
  const { state } = useLocation();
  const jobTitle = state?.jobTitle || 'your application';

  return (
    <section style={{ padding: '4rem 1rem', textAlign: 'center' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>
        Submission received ✅
      </h1>
      <p style={{ marginBottom: '1.25rem' }}>
        Thanks for applying{jobTitle ? ` for ${jobTitle}` : ''}. We’ll review your application and get back to you.
      </p>
      <div style={{ display: 'inline-flex', gap: '0.75rem' }}>
        <Link to="/careers" className="btn btn--outline">Back to Careers</Link>
        <Link to="/" className="btn btn--outline">Go Home</Link>
      </div>
    </section>
  );
}
